/** Espelha estado_associacao_item_nfe_entrada: Pendente pode ter produto escolhido; Associado é a associação confirmada. */
export enum EstadoAssociacaoItemNFeEntradaEnum {
  Pendente = 1,
  Associado = 2,
}
